import RaisedButton from './RaisedButton';

export default RaisedButton;


// WEBPACK FOOTER //
// /src/components/UiComponents/RaisedButton/index.js